import ApiSetting from '@/request/api/setting'
import axios from '@/request/http'
// import querystring from 'querystring'

const imageApi = {
  detail (imgId, params) {
    return axios.get(`${ApiSetting.baseUrl}/api/images/${imgId}/`, {params: params})
  }
}

export default imageApi
